import en from "./en.json";
import it from "./it.json";

const raffle = { it, en };

export default raffle;
